import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCircleHelp = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.85082 5.6643C6.17244 4.464 7.4062 3.75169 8.6065 4.07331C9.8068 4.39493 10.4216 5.4497 10.1 6.65C9.77838 7.8503 8 8.4 8 8.4L8 10",
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 11.8H8.00667",
			stroke: "currentColor",
			strokeWidth: 1.75,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgCircleHelp;
